import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})

export class SessionStorageService {

    constructor() { }

    public saveData(key: string, value: any) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    /**
     * Значение, записанное не через saveData (или испорченное), разбирать нельзя: бросаемое здесь
     * исключение рвёт навигацию (например, гард, читающий адрес возврата после входа). Поэтому
     * значение без JSON и есть null — как и отсутствующий ключ.
     */
    public getData<T>(key: string): T | null {
        const item = sessionStorage.getItem(key);
        if (item === null) return null;

        try {
            return JSON.parse(item) as T;
        } catch {
            return null;
        }
    }

    public removeData(key: string) {
        sessionStorage.removeItem(key);
    }

    public clearData() {
        sessionStorage.clear();
    }
}
